import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import {RequestDetailModel} from "../../../../../models/request-detail-model";
import {EmptyRepoCharges, EmptyRepoRequirements, Ero} from "../../lease-quote-table/lease-quote";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {RequestApiService} from "../../../../../services/domain_code/request-api.service";
import {AuthService} from "../../../../../services/auth.service";
import {MatTableDataSource} from "@angular/material/table";
import {WarningBoxComponent} from "../../../../dialog-box/warning-box/warning-box.component";
import {EmptyRepoQuoteTableComponent} from "../empty-repo-quote-table.component";
import {ApiRoutes} from "../../../../../services/apiroutes";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {CurrencyService} from "../../../../../services/currency.service";

@Component({
    selector: 'logzy-empty-repo-add-charges',
    templateUrl: './empty-repo-add-charges.component.html',
    styleUrls: ['./empty-repo-add-charges.component.scss']
})
export class EmptyRepoAddChargesComponent implements OnInit {

    @Input() requestDetails: RequestDetailModel;
    quoteList;
    chargeList: EmptyRepoCharges = null;
    isCustomer: boolean;
    nonConsolidatedQuoteCharges;
    company_url = `${ApiRoutes.Company}company/`;
    emptyRepoForm!: FormGroup;
    submitted: boolean = false;
    disableSave: boolean = false;
    chargesDataSource;
    displayedColumnsCharges: string[] = [];
    currencyList: any[] = [];

    @Output() savedCharges = new EventEmitter<any>();
    @Output() closeChargesDialog = new EventEmitter<any>();

    currencyUrl = `${ApiRoutes.CurrencyMaster}currency/?currency_code=::search::`

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<EmptyRepoQuoteTableComponent>,
        public requestService: RequestApiService,
        private dialog: MatDialog,
        private authService: AuthService,
        public currencyService: CurrencyService
    ) {
    }

    ngOnInit(): void {
        this.isCustomer = this.authService.isCustomer();
        this.quoteList = this.data.quoteList;
        this.nonConsolidatedQuoteCharges = this.data.nonConsolidatedQuoteCharges;
        console.log('quote', this.quoteList);
        this.emptyRepoForm = new FormGroup({
            charge_name: new FormControl('', [Validators.required]),
            basis: new FormControl('', [Validators.required]),
            rec_amount: new FormControl(0),
            // rec_currency: new FormControl(''),
            rec_remark: new FormControl(''),
            pay_amount: new FormControl(0),
            // pay_currency: new FormControl('USD'),
            pay_remark: new FormControl('', [Validators.required]),
            paid_to: new FormControl('', [Validators.required]),
            currency: new FormControl('', [Validators.required]),
            // requirements: new FormControl([], [Validators.required]),
        });

        this.currencyList = this.currencyService.currencies;

        if (this.isCustomer) {
            // this.emptyRepoForm.controls['rec_currency'].patchValue('USD');
            // this.emptyRepoForm.controls['rec_amount'].setValidators([Validators.required]);
            this.emptyRepoForm.controls['rec_remark'].setValidators([Validators.required]);
            // this.emptyRepoForm.controls['rec_currency'].setValidators([Validators.required]);
        } else {
            // this.emptyRepoForm.controls['rec_currency'].patchValue('');
            // this.emptyRepoForm.controls['rec_amount'].clearValidators();
            this.emptyRepoForm.controls['rec_remark'].clearValidators();
            // this.emptyRepoForm.controls['rec_currency'].clearValidators();
        }

        this.emptyRepoForm.controls['charge_name'].valueChanges.subscribe(value => {
            if (value != null) {
                this.emptyRepoForm.controls['basis'].patchValue(value?.charge?.uom?.value);
            } else
                this.emptyRepoForm.controls['basis'].patchValue('');
        });

        this.emptyRepoForm.controls['currency'].valueChanges.subscribe(value => {
            if (value != null) {
                this.chargesDataSource.data.map(data => {
                    data.rec_currency = value;
                    data.pay_currency = value;
                })
            } else
                this.chargesDataSource.data.map(data => {
                    data.rec_currency = '';
                    data.pay_currency = '';
                })
        });

        this.emptyRepoForm.controls['pay_amount'].valueChanges.subscribe(value => {
            if (value != null) {
                this.chargesDataSource.data.map(data => {
                    data.pay_amount = value;
                })
            } else
                this.chargesDataSource.data.map(data => {
                    data.pay_amount = 0;
                })
        });

        this.emptyRepoForm.controls['rec_amount'].valueChanges.subscribe(value => {
            if (value != null) {
                this.chargesDataSource.data.map(data => {
                    data.rec_amount = value;
                })
            } else
                this.chargesDataSource.data.map(data => {
                    data.rec_amount = 0;
                })
        });

        if (this.isCustomer) {
            this.displayedColumnsCharges = ['requirement', 'rec_amount', 'pay_amount'];
        } else {
            this.displayedColumnsCharges = ['requirement', 'pay_amount'];
        }

        this.chargesDataSource = new MatTableDataSource<null>;
        this.addCommercials();
    }

    get myForm() {
        return this.emptyRepoForm.controls;
    }

    saveChargesDetails() {
        this.submitted = true;
        this.disableSave = true;
        if (this.emptyRepoForm.valid) {
            this.savedCharges.emit(this.emptyRepoForm);
            this.generateCharges(this.emptyRepoForm.value);
        }
        this.disableSave = false;
    }

    cancelChargesDialog() {
        this.closeChargesDialog.emit();
        this.dialogRef.close();
    }

    setPayAmount(event: any) {
        if (event == null) {
            this.emptyRepoForm.controls['pay_amount'].patchValue('');
            this.emptyRepoForm.controls['pay_amount'].setValidators([Validators.required]);
        } else {
            this.emptyRepoForm.controls['pay_amount'].patchValue(event);
            this.emptyRepoForm.controls['pay_amount'].clearValidators();
        }
    }

    setPayCurrency(event: any) {
        if (event == null) {
            this.emptyRepoForm.controls['pay_currency'].patchValue('');
            this.emptyRepoForm.controls['pay_currency'].setValidators([Validators.required]);
        } else {
            this.emptyRepoForm.controls['pay_currency'].patchValue(event);
            this.emptyRepoForm.controls['pay_currency'].clearValidators();
        }
    }

    setRecAmount(event: any) {
        if (event == null) {
            this.emptyRepoForm.controls['rec_amount'].patchValue('');
            this.emptyRepoForm.controls['rec_amount'].setValidators([Validators.required]);
        } else {
            this.emptyRepoForm.controls['rec_amount'].patchValue(event);
            this.emptyRepoForm.controls['rec_amount'].clearValidators();
        }
    }

    setRecCurrency(event: any) {
        if (event == null) {
            this.emptyRepoForm.controls['rec_currency'].patchValue('');
            this.emptyRepoForm.controls['rec_currency'].setValidators([Validators.required]);
        } else {
            this.emptyRepoForm.controls['rec_currency'].patchValue(event);
            this.emptyRepoForm.controls['rec_currency'].clearValidators();
        }
    }

    generateCharges(data: any) {
        let charges = this.chargesDataSource.data.map((req: any) => ({
            requirement: req.requirement,
            charge_name: data.charge_name,
            basis: data.basis,
            rec_remarks: data.rec_remark,
            pay_remarks: data.pay_remark,
            amount: req.rec_amount,
            amount_currency: req.rec_currency,
            pay_amount: req.pay_amount,
            pay_currency: req.pay_currency,
            paid_to: data.paid_to
        }));

        console.log('generateCharges', charges);

        this.dialogRef.close(charges);
    }

    addCommercials() {
        let chargeData: any[] = [];
        let charge;
        this.quoteList.map((quote: any) => {
            charge = new EmptyRepoRequirements();
            charge.requirement = quote;
            chargeData.push({...charge});
            this.chargesDataSource.data = chargeData;
        });

        // let chargeData: any[] = [];
        // if (this.chargesDataSource.data.length == 0) {
        //     chargeData.push({...new EmptyRepoRequirements()});
        //     this.chargesDataSource.data = chargeData;
        // } else {
        //     const newData = [...this.chargesDataSource.data];
        //     newData.push({...new EmptyRepoRequirements()});
        //     this.chargesDataSource.data = newData;
        // }
        console.log(this.chargesDataSource.data);
    }

    deleteCharge(idx) {
        const newData = [...this.chargesDataSource.data];
        newData.splice(idx, 1);
        this.chargesDataSource.data = newData;
    }
}
